import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { PurchaseMethodsV25, Vehicle, Quote } from '@sm360/widget-commons-vehicle';

import * as Actions from 'payment-calculator-v25/actions/paymentCalculatorActions.js';

import CalculatorTradein from 'payment-calculator-v25/components/PaymentCalculatorDetails/components/CalculatorTradein/CalculatorTradein.jsx';

import 'payment-calculator-v25/components/PaymentCalculatorDetails/components/CashMethodPage/CashMethodPage.scss';

const { AmountLineItem } = PurchaseMethodsV25;

const CASH_DOWN = 'cashDown';
class CashMethodPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showPurchaseDetail: false,
        };

        this.showPurchaseDetail = this.showPurchaseDetail.bind(this);
    }

    showPurchaseDetail() {
        this.setState({
            showPurchaseDetail: !this.state.showPurchaseDetail,
        });
    }

    render() {
        const { purchaseMethods, tradeInVehicle, actions } = this.props;
        // eslint-disable-next-line no-unused-vars
        const { transactionBase = [], transactionTotal = [] } = purchaseMethods.getCalculatorCashTransactionPrices();

        return (
            <div className="purchase-methods-cash calculatorRow">
                <div className="calculatorColumn is-light pdsf_calculator">
                    <div className="price-wrapper clearfix sr-paymentCalculator-EmphasisColor is-light">
                        <span className="price-title sr-subtitle-2 sr-paymentCalculator-EmphasisColor is-alternate">
                            <icon className="icon-review" />{' '}
                            {LocaleService.t('PAYMENT_CALCULATOR_V25.PURCHASEMETHODS.OUR_PRICE')}
                        </span>
                    </div>
                    {transactionBase.map((transaction, index) => (
                        <AmountLineItem
                            label={transaction?.name}
                            amount={transaction?.amount || 0}
                            subItem={transaction?.items}
                            category={transaction?.category}
                            isTotal={transaction?.isTotal}
                            transactionIndex={index}
                        />
                    ))}
                </div>
                <div className="calculatorColumn is-light obligationsTotal">
                    <div className="price-wrapper clearfix sr-paymentCalculator-EmphasisColor is-light">
                        <span className="price-title sr-subtitle-2 sr-paymentCalculator-EmphasisColor is-alternate">
                            &nbsp;
                            {/* Removed for STS-3875 */}
                            {/* {LocaleService.t('PAYMENT_CALCULATOR_V25.PURCHASEMETHODS.TOTAL_OBLIGATIONS')} */}
                        </span>
                    </div>
                    {transactionTotal
                        .filter((trans) => trans.category !== CASH_DOWN)
                        .map((transaction, index) => (
                            <AmountLineItem
                                label={transaction?.code !== 'T2' && transaction?.name}
                                amount={transaction?.amount || 0}
                                subItem={transaction?.items}
                                category={transaction?.category}
                                isTotal={transaction?.isTotal}
                                isLast={index + 1 === transactionTotal?.length}
                                transactionIndex={index}
                            />
                        ))}
                    <div className="calculatorColumn__disclaimer">
                        {LocaleService.t('PAYMENT_CALCULATOR_V25.DISCLAIMER')}
                    </div>
                </div>
                <div className="calculatorColumn">
                    <CalculatorTradein
                        tradeInVehicle={tradeInVehicle}
                        tradeIn={purchaseMethods.tradeIn}
                        lien={purchaseMethods.lien}
                        setTradeIn={actions.setTradeIn}
                        setLien={actions.setLien}
                        setTradeInAndLien={actions.setTradeInAndLien}
                        purchaseMethods={purchaseMethods}
                        quote={this.props.quote}
                        config={this.props.config}
                        setShiftEvent={actions.setShiftEvent}
                    />
                    {/* Not provided by the backend V2.5 (DATA-4959)
                    <CalculatorRebateStandardRate stdRebate={purchaseMethods.getSelectedRebatesAtStandardRate()} /> */}
                </div>
            </div>
        );
    }
}

CashMethodPage.propTypes = {
    purchaseMethods: PropTypes.instanceOf(PurchaseMethodsV25.PurchaseMethodsModelV25).isRequired,
    tradeInVehicle: PropTypes.instanceOf(Vehicle.TradeInVehicleModel).isRequired,
    quote: PropTypes.instanceOf(Quote.QuoteModelV25).isRequired,
    actions: PropTypes.shape({
        setTradeIn: PropTypes.func.isRequired,
        setLien: PropTypes.func.isRequired,
        setTradeInAndLien: PropTypes.func.isRequired,
    }),
};

CashMethodPage.displayName = 'CashMethodPage';

function mapStateToProps(state) {
    return {
        purchaseMethods: state.purchaseMethodsV25,
        tradeInVehicle: state.tradeInVehicle,
        quote: state.quoteV25,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CashMethodPage);
